import React, { useMemo } from 'react'
import { Line } from '@react-three/drei'

const OutLineSection = ({ width, height, isDeleted, canClone }) => {
    const offset = 0.1;

    const topLinePoints = useMemo(() => (
            [
                [-(width / 2 + offset), 0.15, 0],
                [-(width / 2 + offset), height + offset, 0],
                [(width / 2 + offset), height + offset, 0],
                [(width / 2 + offset), 0.15, 0],
                [-(width / 2 + offset), 0.15, 0],
            ]
    ), [width, height])
    
    return (
        <group position={[0, -height / 2, 0.35]}>
            <Line
                points={topLinePoints}
                color={isDeleted ? '#D5121A' : !canClone? "#FD8900" : "#1FAC48"}
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
        </group>
    )
}

export default OutLineSection